import React from 'react';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import styles from './AboutSection.module.css';
import { trackCtaClick } from '../../../../utils/analytics';

// Ícone de usuários (benefício 1)
const UsersIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#7C3AED" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="7" r="4" stroke="#7C3AED" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="#7C3AED" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="#7C3AED" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Ícone de escudo (benefício 2)
const ShieldIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="#7C3AED" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 12l2 2 4-4" stroke="#7C3AED" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Ícone de coração (benefício 3)
const HeartIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="#E91E8C" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Ícone WhatsApp (floating card)
const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" fill="#25D366" stroke="#25D366" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Ícone de dólar (floating card)
const DollarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="12" y1="1" x2="12" y2="23" stroke="#F97316" strokeWidth="2" strokeLinecap="round"/>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="#F97316" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Ícone de sino (floating card)
const BellIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Ícone relógio (métricas)
const ClockIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="#7C3AED" strokeWidth="1.8"/>
    <polyline points="12 6 12 12 16 14" stroke="#7C3AED" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Ícone calendário (métricas)
const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="#E91E8C" strokeWidth="1.8"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke="#E91E8C" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke="#E91E8C" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke="#E91E8C" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

// Ícone mensagem (métricas)
const MessageIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Ícone gráfico (métricas)
const ChartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="18" y1="20" x2="18" y2="10" stroke="#F97316" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="12" y1="20" x2="12" y2="4" stroke="#F97316" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="6" y1="20" x2="6" y2="14" stroke="#F97316" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const BENEFITS = [
  {
    icon: <UsersIcon />,
    title: 'Feita por quem vive essa rotina',
    description: 'Entendemos os desafios do dia a dia porque já estivemos do seu lado.',
    iconBg: 'rgba(124, 58, 237, 0.08)',
  },
  {
    icon: <ShieldIcon />,
    title: 'Tudo em um só lugar',
    description: 'Agenda, pacientes, prontuários, documentos e financeiro conectados, sem retrabalho e sem informação espalhada.',
    iconBg: 'rgba(124, 58, 237, 0.08)',
  },
  {
    icon: <HeartIcon />,
    title: 'Menos burocracia no seu dia',
    description: 'Automatizamos as tarefas repetitivas para você se dedicar ao que realmente faz diferença: as pessoas que você atende.',
    iconBg: 'rgba(233, 30, 140, 0.08)',
  },
];

const METRICS = [
  {
    icon: <ClockIcon />,
    bold: 'Processos mais ágeis',
    normal: 'e sem retrabalho',
    iconBg: 'rgba(124, 58, 237, 0.08)',
  },
  {
    icon: <CalendarIcon />,
    bold: 'Agenda organizada',
    normal: 'e sem conflitos',
    iconBg: 'rgba(233, 30, 140, 0.08)',
  },
  {
    icon: <MessageIcon />,
    bold: 'Comunicação integrada',
    normal: 'e sem retrabalho',
    iconBg: 'rgba(59, 130, 246, 0.08)',
  },
  {
    icon: <ChartIcon />,
    bold: 'Dados e resultados',
    normal: 'sempre à mão',
    iconBg: 'rgba(249, 115, 22, 0.08)',
  },
];

function AboutSection({ onScrollToBeta }) {
  return (
    <section id="como-funciona" className={styles.aboutSection}>
      {/* Decorative background blobs */}
      <div className={styles.blobTopRight} aria-hidden="true" />
      <div className={styles.blobBottomLeft} aria-hidden="true" />

      {/* ── DESKTOP: layout 2 colunas original ── */}
      <div className={`${styles.sectionContainer} ${styles.aboutDesktopOnly}`}>
        {/* ── Main 2-column grid ── */}
        <div className={styles.mainGrid}>

          {/* ── LEFT COLUMN ── */}
          <div className={styles.leftColumn}>
            {/* Eyebrow */}
            <span className={styles.eyebrow}>NASCIDA DENTRO DE UMA CLÍNICA REAL</span>

            {/* Title */}
            <h2 className={styles.sectionTitle}>
              A Gabriela foi criada<br />
              para a{' '}
              <span className={styles.gradientText}>rotina de verdade</span>
              <br />
              de quem atende pessoas.
            </h2>

            {/* Decorative line */}
            <div className={styles.titleDecorLine} aria-hidden="true" />

            {/* Paragraph */}
            <p className={styles.description}>
              Depois de anos lidando com papel, planilhas, mensagens soltas e sistemas complicados, criamos uma plataforma simples que reúne agenda, pacientes, prontuários, documentos, financeiro e comunicação em um só lugar.
            </p>

            {/* Benefits list */}
            <ul className={styles.benefitsList}>
              {BENEFITS.map((benefit, idx) => (
                <li key={idx} className={styles.benefitItem}>
                  <span
                    className={styles.benefitIconWrap}
                    style={{ background: benefit.iconBg }}
                  >
                    {benefit.icon}
                  </span>
                  <div className={styles.benefitText}>
                    <strong className={styles.benefitTitle}>{benefit.title}</strong>
                    <span className={styles.benefitDesc}>{benefit.description}</span>
                  </div>
                </li>
              ))}
            </ul>

            {/* CTA Button */}
            <button
              className={styles.ctaButton}
              onClick={() => {
                trackCtaClick({ placement: 'about_section_cta' });
                onScrollToBeta();
              }}
            >
              Ver como funciona
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '8px' }}>
                <path d="M5 12h14M12 5l7 7-7 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          {/* ── RIGHT COLUMN ── */}
          <div className={styles.rightColumn}>
            <div className={styles.imageWrapper}>
              {/* Main image */}
              <img
                src="/assets/about.png"
                alt="Profissional de saúde usando a Gabriela"
                className={styles.mainImage}
              />

              {/* Floating card 1 — top right: Horário confirmado pelo link */}
              <div className={`${styles.floatingCard} ${styles.cardTopRight}`}>
                <div className={styles.cardIconWrap} style={{ background: 'rgba(37, 211, 102, 0.12)' }}>
                  <WhatsAppIcon />
                </div>
                <div className={styles.cardContent}>
                  <span className={styles.cardTitle}>Horário confirmado</span>
                  <span className={styles.cardSub}>Ana C. P. Muniz confirmou pelo link</span>
                </div>
              </div>

              {/* Floating card 2 — bottom left: Faturamento */}
              <div className={`${styles.floatingCard} ${styles.cardBottomLeft}`}>
                <div className={styles.cardIconWrap} style={{ background: 'rgba(249, 115, 22, 0.12)' }}>
                  <DollarIcon />
                </div>
                <div className={styles.cardContent}>
                  <span className={styles.cardTitle}>Faturamento do dia</span>
                  <span className={styles.cardValue}>R$ 3.450,00</span>
                  <span className={styles.cardBadge}>+12% vs ontem</span>
                </div>
              </div>

              {/* Floating card 3 — bottom right: Lembrete pronto, um clique abre o WhatsApp Web */}
              <div className={`${styles.floatingCard} ${styles.cardBottomRight}`}>
                <div className={styles.cardIconWrap} style={{ background: 'rgba(59, 130, 246, 0.12)' }}>
                  <BellIcon />
                </div>
                <div className={styles.cardContent}>
                  <span className={styles.cardTitle}>Lembrete pronto</span>
                  <span className={styles.cardSub}>João M. · amanhã às 10h</span>
                  <span className={styles.cardAction}>Abrir no WhatsApp</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── DESKTOP: Metrics bar ── */}
      <div className={`${styles.metricsBar} ${styles.aboutDesktopOnly}`}>
        <div className={styles.metricsInner}>
          {METRICS.map((metric, idx) => (
            <React.Fragment key={idx}>
              <div className={styles.metricItem}>
                <span
                  className={styles.metricIconWrap}
                  style={{ background: metric.iconBg }}
                >
                  {metric.icon}
                </span>
                <div className={styles.metricText}>
                  <strong className={styles.metricBold}>{metric.bold}</strong>
                  <span className={styles.metricNormal}>{metric.normal}</span>
                </div>
              </div>
              {idx < METRICS.length - 1 && (
                <div className={styles.metricDivider} aria-hidden="true" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* ── MOBILE: versão premium compacta ── */}
      <div className={styles.mobileAboutSection}>
        {/* Header */}
        <div className={styles.mobileAboutHeader}>
          <span className={styles.mobileAboutEyebrow}>NASCIDA DENTRO DE UMA CLÍNICA REAL</span>
          <h2 className={styles.mobileAboutTitle}>
            Feita para a rotina <span className={styles.mobileAboutHighlight}>de verdade</span>
          </h2>
          <p className={styles.mobileAboutSubtitle}>
            Criamos uma plataforma simples e completa para quem quer organizar seu atendimento e ganhar tempo.
          </p>
        </div>

        {/* Imagem com card flutuante sobreposto */}
        <div className={styles.mobileAboutImageArea}>
          <img
            src="/assets/about.png"
            alt="Profissional de saúde usando a Gabriela"
            className={styles.mobileAboutImage}
          />
          {/* Card flutuante de segurança */}
          <div className={styles.mobileAboutFloatingCard}>
            <div className={styles.mobileAboutCardIcon}><ShieldOutlinedIcon fontSize="inherit" /></div>
            <div className={styles.mobileAboutCardContent}>
              <div className={styles.mobileAboutCardTitle}>Dados 100% seguros</div>
              <div className={styles.mobileAboutCardSub}>Privacidade e segurança dos dados</div>
              <div className={styles.mobileAboutCardBadge}><CheckRoundedIcon fontSize="inherit" /> Certificado SSL</div>
            </div>
          </div>
        </div>

        {/* Benefícios compactos */}
        <div className={styles.mobileAboutBenefits}>
          {BENEFITS.map((benefit, idx) => (
            <div key={idx} className={styles.mobileAboutBenefitItem}>
              <div
                className={styles.mobileAboutBenefitIcon}
                style={{ background: benefit.iconBg }}
              >
                {benefit.icon}
              </div>
              <div className={styles.mobileAboutBenefitText}>
                <strong className={styles.mobileAboutBenefitTitle}>{benefit.title}</strong>
                <span className={styles.mobileAboutBenefitDesc}>{benefit.description}</span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <button
          className={styles.mobileAboutCta}
          onClick={() => {
            trackCtaClick({ placement: 'about_mobile_cta' });
            onScrollToBeta();
          }}
        >
          Ver como funciona →
        </button>

        {/* Métricas 2x2 */}
        <div className={styles.mobileAboutMetrics}>
          {METRICS.map((metric, idx) => (
            <div key={idx} className={styles.mobileAboutMetricItem}>
              <div
                className={styles.mobileAboutMetricIcon}
                style={{ background: metric.iconBg }}
              >
                {metric.icon}
              </div>
              <div>
                <strong className={styles.mobileAboutMetricBold}>{metric.bold}</strong>
                <span className={styles.mobileAboutMetricNormal}>{metric.normal}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}

export default AboutSection;
